import { IncludeType } from '../../../common';
import { Group } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getGroupsByIds = async (
  groupIds: number[],
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Group[] | null> => {
  try {
    if (!groupIds.length) {
      console.warn('No group IDs provided for fetching groups');
      return null;
    }

    const queryParams = new URLSearchParams({
      ids: groupIds.join('|'),
      include: includeType,
      marketLocale: locale,
    }).toString();

    const url = `/group/filter?${queryParams}`;
    const response = await productCatalogueHttp.get<Group[]>(url);

    return response?.data?.length ? response.data : null;
  } catch (error) {
    console.error(`Failed to fetch groups for groupIds: ${groupIds.join(', ')}`, error);
    return null;
  }
};
